import { render, staticRenderFns } from "./Demandes.vue?vue&type=template&id=b873636e&scoped=true&"
import script from "./Demandes.vue?vue&type=script&lang=js&"
export * from "./Demandes.vue?vue&type=script&lang=js&"
import style0 from "./Demandes.vue?vue&type=style&index=0&id=b873636e&prod&lang=scss&scoped=true&"
import style1 from "./Demandes.vue?vue&type=style&index=1&id=b873636e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b873636e",
  null
  
)

export default component.exports